import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import { ThemeProvider } from '@material-ui/core/styles';
import Theme from '../theme/CustomTheme'
import NumberFormat from 'react-number-format';
import { FormControl, InputLabel, Select, MenuItem, Button, FormHelperText } from '@material-ui/core';
import useStyles from '../styles/CustomStyle'
import "../styles/ResponsiveStyle.css"
import { referenceCtrls, cities, dhkAreas, ctgAreas, sylhetAreas, coxsAreas, rajAreas, khulnaAreas, barAreas, bogAreas, cumAreas, jessoreAreas, noaAreas, rangAreas, bagerhatAreas, bandarbanAreas, bargunaAreas, bholaAreas, brahamanbariaAreas, chandpurAreas, chuadangaAreas, dinajpurAreas, faridpurAreas, feniAreas, gaibandhaAreas, gazipurAreas, gopalganjAreas, habiganjAreas, jamalpurAreas, jhalokatiAreas, jhenaidahAreas, joypurhatAreas, khagrachhariAreas, kishoreganjAreas, kurigramAreas, kushtiaAreas, lakshmipurAreas, lalmonirhatAreas, madaripurAreas, maguraAreas, manikganjAreas, maulvibazarAreas, meherpurAreas, munshiganjAreas, mymensinghAreas, naogaonAreas, narailAreas, narayanganjAreas, narsingdiAreas, natoreAreas, nawabganjAreas, netrakonaAreas, nilphamariAreas, pabnaAreas, panchagarhAreas, patuakhaliAreas, pirojpurAreas, rajbariAreas, rangamatiAreas, satkhiraAreas, shariatpurAreas, sherpurAreas, sirajganjAreas, sunamganjAreas, tangailAreas, thakurgaonAreas } from '../Data/Data'

export default function BasicInformation(props) {
  const classes = useStyles();
  const msg = "This is a required field";
  let rePhone = /^(?:\+?88)?01[3-9]\d{8}$/
  // let reEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  const [error, setError] = React.useState({
    nameCtrl: false,
    genderCtrl: false,
    phoneCtrl: {
      isEmpty: false,
      invalid: false
    },
    emailCtrl: {
      isEmpty: false,
      invalid: false
    },
    city: false,
    area: false,
    referenceCtrl: false,
    salesPerson: false
  })

  const handleChange = (e, flag) => {
    if (flag === "phoneCtrl") {
      setError({
        ...error,
        phoneCtrl: {
          isEmpty: false,
          invalid: false
        }
      });
    } else if (e.target.name === "city") {
      setError({
        ...error,
        [e.target.name]: false
      })
      if (e.target.value === "Dhaka") {
        props.setAreas(dhkAreas);
      } else if (e.target.value === "Chittagong") {
        props.setAreas(ctgAreas);
      } else if (e.target.value === "Sylhet") {
        props.setAreas(sylhetAreas);
      } else if (e.target.value === "Coxs Bazar") {
        props.setAreas(coxsAreas);
      } else if (e.target.value === "Rajshahi") {
        props.setAreas(rajAreas);
      } else if (e.target.value === "Jessore") {
        props.setAreas(jessoreAreas);
      } else if (e.target.value === "Khulna") {
        props.setAreas(khulnaAreas);
      } else if (e.target.value === 'Bogura') {
        props.setAreas(bogAreas);
      } else if (e.target.value === 'Noakhali') {
        props.setAreas(noaAreas);
      } else if (e.target.value === 'Cumilla') {
        props.setAreas(cumAreas);
      } else if (e.target.value === 'Barisal') {
        props.setAreas(barAreas);
      } else if (e.target.value === 'Rangpur') {
        props.setAreas(rangAreas);
      }

      else if (e.target.value === "Bagerhat") {
        props.setAreas(bagerhatAreas);
      } else if (e.target.value === "Bandarban") {
        props.setAreas(bandarbanAreas);
      } else if (e.target.value === "Barguna") {
        props.setAreas(bargunaAreas);
      } else if (e.target.value === "Bhola") {
        props.setAreas(bholaAreas);
      } else if (e.target.value === "Brahamanbaria") {
        props.setAreas(brahamanbariaAreas);
      } else if (e.target.value === "Chandpur") {
        props.setAreas(chandpurAreas);
      } else if (e.target.value === "Chuadanga") {
        props.setAreas(chuadangaAreas);
      } else if (e.target.value === 'Dinajpur') {
        props.setAreas(dinajpurAreas);
      } else if (e.target.value === 'Faridpur') {
        props.setAreas(faridpurAreas);
      } else if (e.target.value === 'Feni') {
        props.setAreas(feniAreas);
      } else if (e.target.value === 'Gaibandha') {
        props.setAreas(gaibandhaAreas);
      } else if (e.target.value === 'Gazipur') {
        props.setAreas(gazipurAreas);
      }

      else if (e.target.value === "Gopalganj") {
        props.setAreas(gopalganjAreas);
      } else if (e.target.value === "Habiganj") {
        props.setAreas(habiganjAreas);
      } else if (e.target.value === "Jamalpur") {
        props.setAreas(jamalpurAreas);
      } else if (e.target.value === "Jhalokati") {
        props.setAreas(jhalokatiAreas);
      } else if (e.target.value === "Jhenaidah") {
        props.setAreas(jhenaidahAreas);
      } else if (e.target.value === "Joypurhat") {
        props.setAreas(joypurhatAreas);
      } else if (e.target.value === 'Khagrachhari') {
        props.setAreas(khagrachhariAreas);
      } else if (e.target.value === 'Kishoreganj') {
        props.setAreas(kishoreganjAreas);
      } else if (e.target.value === 'Kurigram') {
        props.setAreas(kurigramAreas);
      } else if (e.target.value === 'Kushtia') {
        props.setAreas(kushtiaAreas);
      } else if (e.target.value === 'Lakshmipur') {
        props.setAreas(lakshmipurAreas);
      }

      else if (e.target.value === "Lalmonirhat") {
        props.setAreas(lalmonirhatAreas);
      } else if (e.target.value === "Madaripur") {
        props.setAreas(madaripurAreas);
      } else if (e.target.value === "Magura") {
        props.setAreas(maguraAreas);
      } else if (e.target.value === "Manikganj") {
        props.setAreas(manikganjAreas);
      } else if (e.target.value === "Maulvibazar") {
        props.setAreas(maulvibazarAreas);
      } else if (e.target.value === "Meherpur") {
        props.setAreas(meherpurAreas);
      } else if (e.target.value === 'Munshiganj') {
        props.setAreas(munshiganjAreas);
      } else if (e.target.value === 'Mymensingh') {
        props.setAreas(mymensinghAreas);
      } else if (e.target.value === 'Naogaon') {
        props.setAreas(naogaonAreas);
      } else if (e.target.value === 'Narail') {
        props.setAreas(narailAreas);
      } else if (e.target.value === 'Natore') {
        props.setAreas(natoreAreas);
      }

      else if (e.target.value === "Nawabganj") {
        props.setAreas(nawabganjAreas);
      } else if (e.target.value === "Narayanganj") {
        props.setAreas(narayanganjAreas);
      } else if (e.target.value === "Narsingdi") {
        props.setAreas(narsingdiAreas);
      } else if (e.target.value === "Netrakona") {
        props.setAreas(netrakonaAreas);
      } else if (e.target.value === "Nilphamari") {
        props.setAreas(nilphamariAreas);
      } else if (e.target.value === "Pabna") {
        props.setAreas(pabnaAreas);
      } else if (e.target.value === "Panchagarh") {
        props.setAreas(panchagarhAreas);
      } else if (e.target.value === "Patuakhali") {
        props.setAreas(patuakhaliAreas);
      } else if (e.target.value === 'Pirojpur') {
        props.setAreas(pirojpurAreas);
      } else if (e.target.value === 'Rajbari') {
        props.setAreas(rajbariAreas);
      } else if (e.target.value === 'Rangamati') {
        props.setAreas(rangamatiAreas);
      } else if (e.target.value === 'Satkhira') {
        props.setAreas(satkhiraAreas);
      } else if (e.target.value === 'Shariatpur') {
        props.setAreas(shariatpurAreas);
      }

      else if (e.target.value === "Sherpur") {
        props.setAreas(sherpurAreas);
      } else if (e.target.value === "Sirajganj") {
        props.setAreas(sirajganjAreas);
      } else if (e.target.value === "Sunamgabj") {
        props.setAreas(sunamganjAreas);
      } else if (e.target.value === "Tangail") {
        props.setAreas(tangailAreas);
      } else if (e.target.value === "Thakurgaon") {
        props.setAreas(thakurgaonAreas);
      }
    }
    else {
      setError({
        ...error,
        [e.target.name]: false
      })
    }

    props.handleChange(e, flag)

  }

  const handleValidate = (e) => {
    e.preventDefault();
    if (!props.stepContent.nameCtrl) {
      setError({
        ...error,
        nameCtrl: true
      });

    } else if (!props.stepContent.genderCtrl) {
      setError({
        ...error,
        genderCtrl: true
      });
    } else if (!props.stepContent.phoneCtrl) {
      setError({
        ...error,
        phoneCtrl: {
          isEmpty: true
        }
      });
    } else if (!rePhone.test(props.stepContent.phoneCtrl)) {
      setError({
        ...error,
        phoneCtrl: {
          invalid: true
        }
      });
    } else if (!props.stepContent.city) {
      setError({
        ...error,
        city: true
      });
    } else if (!props.stepContent.area) {
      setError({
        ...error,
        area: true
      });
    } else if (!props.stepContent.referenceCtrl) {
      setError({
        ...error,
        referenceCtrl: true
      });
    } else if (props.stepContent.referenceCtrl === "Sales Force") {
      if (!props.stepContent.salesPerson) {
        setError({
          ...error,
          salesPerson: true
        });
      } else {
        props.handleNext();
      }
    } else {
      props.handleNext();
    }
  }

  const hadnleOnBlur = (flag) => {
    if (flag === "phoneCtrl") {
      if (!rePhone.test(props.stepContent.phoneCtrl)) {
        setError({
          ...error,
          phoneCtrl: {
            invalid: true
          }
        });
      } else {
        setError({
          ...error,
          phoneCtrl: {
            invalid: false
          }
        });
      }
    }
  }

  return (
    <React.Fragment>
      <Typography variant="h4" gutterBottom className="title" style={{ textAlign: "center", padding: "10px 0 20px 0" }}>
        Basic Information
      </Typography>
      <form>
        <ThemeProvider theme={Theme}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <TextField
                required
                error={error.nameCtrl}
                // helperText="Incorrect entry."
                value={props.stepContent.nameCtrl}
                onChange={handleChange}
                id="nameCtrl"
                name="nameCtrl"
                label="Full name"
                fullWidth
                autoComplete="fname"
                helperText={error.nameCtrl ?
                  msg : ""
                }
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl required className={classes.formControl} error={error.genderCtrl} >
                <InputLabel id="genderCtrl-label">Gender</InputLabel>
                <Select
                  labelId="genderCtrl"
                  id="genderCtrl"
                  value={props.stepContent.genderCtrl}
                  name="genderCtrl"
                  onChange={handleChange}
                >
                  <MenuItem value="0">Male</MenuItem>
                  <MenuItem value="1">Female</MenuItem>
                </Select>
                {
                  error.genderCtrl ?
                    <FormHelperText>
                      {msg}
                    </FormHelperText> : ""
                }
              </FormControl>

            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl className={classes.formControl} required error={error.phoneCtrl.isEmpty || error.phoneCtrl.invalid}>
                <NumberFormat
                  error={error.phoneCtrl.isEmpty || error.phoneCtrl.invalid}
                  onBlur={() => hadnleOnBlur("phoneCtrl")}
                  name="phone"
                  variant="outlined"
                  placeholder="Phone Number"
                  customInput={TextField}
                  format="+88###########"
                  value={props.stepContent.phoneCtrl}
                  onValueChange={(values) => {
                    handleChange(values.formattedValue, "phoneCtrl")
                  }}
                />
                {
                  error.phoneCtrl.isEmpty ?
                    <FormHelperText>
                      {msg}
                    </FormHelperText> : "" || error.phoneCtrl.invalid ? <FormHelperText>Invalid phone number</FormHelperText> : ""
                }
              </FormControl>

            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Email"
                id="emailCtrl"
                type="email"
                name="emailCtrl"
                onBlur={() => hadnleOnBlur("emailCtrl")}
                onChange={handleChange}
                fullWidth                
                value={props.stepContent.emailCtrl}
                autoComplete="email"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl className={classes.formControl} required error={error.city}>
                <InputLabel id="city-label">City</InputLabel>
                <Select
                  labelId="city"
                  id="city"
                  value={props.stepContent.city}
                  onChange={handleChange}
                  name="city"
                >
                  {
                    cities.map(item => (
                      <MenuItem key={item} value={item}>{item}</MenuItem>
                    ))
                  }
                </Select>
                {
                  error.city ?
                    <FormHelperText>
                      {msg}
                    </FormHelperText> : ""
                }
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl className={classes.formControl} required error={error.area}>
                <InputLabel id="area-label">Area</InputLabel>
                <Select
                  labelId="area"
                  id="area"
                  name="area"
                  value={props.stepContent.area}
                  onChange={handleChange}
                >
                  {
                    props.areas.map(item => (
                      <MenuItem key={item} value={item}>{item}</MenuItem>
                    ))
                  }
                </Select>
                {
                  error.area ?
                    <FormHelperText>
                      {msg}
                    </FormHelperText> : ""
                }
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <FormControl className={classes.formControl} required error={error.referenceCtrl}>
                <InputLabel id="where-did-you-hear-label">Where did you hear about Obhai?</InputLabel>
                <Select
                  labelId="where-did-you-hear"
                  id="where-did-you-hear"
                  name="referenceCtrl"
                  value={props.stepContent.referenceCtrl}
                  onChange={handleChange}
                >
                  {
                    referenceCtrls.map(item => (
                      <MenuItem key={item} value={item}>{item}</MenuItem>
                    ))
                  }
                </Select>
                {
                  error.referenceCtrl ? <FormHelperText>{msg}</FormHelperText> : ""
                }
              </FormControl>
            </Grid>
            {
              props.stepContent.referenceCtrl === "Sales Force" ?
                <Grid item xs={12}>
                  <TextField
                    error={error.salesPerson}
                    label="Name of Sales Person"
                    id="salesPerson"
                    name="salesPerson"
                    onChange={handleChange}
                    fullWidth
                    required
                    value={props.stepContent.salesPerson}
                    autoComplete="name"
                    helperText={error.salesPerson ?
                      msg : ""
                    }
                    variant="outlined"
                  />
                </Grid> : ""
            }
          </Grid>
          <div className={classes.buttons}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleValidate}
              type="submit"
              className={classes.button}
            >
              Next
            </Button>
          </div>
        </ThemeProvider>
      </form>
    </React.Fragment>
  );
}